module.exports = __webpack_public_path__ + "img/5.cb6f08e2.png";